import React from 'react'
import HomeTop from '../Utils/HomeTop';
import HomeWelcome from '../Utils/HomeWelcome';
import HomeInitiative from '../Utils/HomeInitiative';
import Footer from '../Utils/Footer';

export default function Home() {




  return (
    <div>
      <HomeTop />
      <HomeWelcome />
      <HomeInitiative />
      <Footer />
      {/* <button onClick={() => {

        auth.Logout_frontend();
        navigate("/");

      }}>Logout</button> */}

    </div>

  )
}
